<template>
  <ul id="tabs-navbar" class="tabs">
    <li class="tab">
      <a @click="alteraTab('inicio')" v-bind:class="tabInicio" href="#welcome">Boas-vindas</a>
    </li>
    <li class="tab">
      <a
        v-bind:class="tabNovaSimulacao"
        href="#new_simulation"
        @click="alteraTab('nova-simulacao')"
      >Nova Simulação</a>
    </li>
    <li class="tab">
      <a
        v-bind:class="tabMinhasSimulacoes"
        href="#my_simulations"
        @click="alteraTab('minhas-simulacoes')"
      >Minhas Simulações</a>
    </li>
  </ul>
</template>
<script>
import $ from "jquery";
import M from "materialize-css";
export default {
  name: "Tabs",
  props: {
    tabMinhasSimulacoes: String,
    tabInicio: String,
    tabNovaSimulacao: String
  },
  methods: {
    alteraTab: function(tab_value) {
      this.$emit("DefineTab", {
        tab: tab_value
      });
      this.$router.push("/home/"+tab_value);
    }
  },
  mounted() {
    M.Tabs.init($(".tabs"));
  }
};
</script>